import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SidebarProvider } from './context/SidebarContext';
import PrivateRoute from './routes/PrivateRoute';
import AdminRoute from './routes/AdminRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/Home';
import Pricing from './pages/Pricing';
import ApiCredits from './pages/ApiCredits';
import Login from './pages/Login';
import Signup from './pages/Signup';

import DashboardLayout from './pages/dashboard/DashboardLayout';
import Overview from './pages/dashboard/Overview';
import ApiKeys from './pages/dashboard/ApiKeys';
import Endpoints from './pages/dashboard/Endpoints';
import UsageLogs from './pages/dashboard/UsageLogs';
import Wallet from './pages/dashboard/Wallet';
import Billing from './pages/dashboard/Billing';
import Profile from './pages/dashboard/Profile';

import AdminLayout from './pages/admin/AdminLayout';
import AdminOverview from './pages/admin/AdminOverview';
import Networks from './pages/admin/Networks';
import RpcProviders from './pages/admin/RpcProviders';
import MethodCosts from './pages/admin/MethodCosts';
import Plans from './pages/admin/Plans';
import Users from './pages/admin/Users';
import Deposits from './pages/admin/Deposits';
import RpcLogs from './pages/admin/RpcLogs';

function PublicLayout({ children }) {
  return (
    <SidebarProvider>
      <Navbar />
      {children}
      <Footer />
    </SidebarProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/pricing" element={<PublicLayout><Pricing /></PublicLayout>} />
          <Route path="/api-credits" element={<PublicLayout><ApiCredits /></PublicLayout>} />
          <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
          <Route path="/signup" element={<PublicLayout><Signup /></PublicLayout>} />

          <Route element={<PrivateRoute />}>
            <Route element={<PublicLayout><DashboardLayout /></PublicLayout>}>
              <Route path="/dashboard" element={<Overview />} />
              <Route path="/dashboard/api-keys" element={<ApiKeys />} />
              <Route path="/dashboard/endpoints" element={<Endpoints />} />
              <Route path="/dashboard/usage" element={<UsageLogs />} />
              <Route path="/dashboard/wallet" element={<Wallet />} />
              <Route path="/dashboard/billing" element={<Billing />} />
              <Route path="/dashboard/profile" element={<Profile />} />
            </Route>
          </Route>

          <Route element={<AdminRoute />}>
            <Route element={<PublicLayout><AdminLayout /></PublicLayout>}>
              <Route path="/admin" element={<AdminOverview />} />
              <Route path="/admin/networks" element={<Networks />} />
              <Route path="/admin/rpc-providers" element={<RpcProviders />} />
              <Route path="/admin/method-costs" element={<MethodCosts />} />
              <Route path="/admin/plans" element={<Plans />} />
              <Route path="/admin/users" element={<Users />} />
              <Route path="/admin/deposits" element={<Deposits />} />
              <Route path="/admin/rpc-logs" element={<RpcLogs />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
